module.exports = __webpack_public_path__ + "static/media/how-it-works-reman-1.74702e8c.png";